export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';


export const MODAL_CLICKED = 'MODAL_CLICKED';

export const SET_AUTH_REDIRECT_PATH = 'SET_AUTH_REDIRECT_PATH';


// WEBPACK FOOTER //
// ./src/store/actions/actionTypes.js